module.exports = __webpack_public_path__ + "img/tuiguang3-1.1eaac77f.png";